module.exports = __webpack_public_path__ + "img/reconcile.4f9a03d4.svg";